import React from 'react';
import { FileTextIcon, CheckIcon } from 'lucide-react';
import { formatPoints } from '../data/content';
export function FormatSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="format-heading" data-id="element-123" data-mp="1zjwdjl6du21r">
      <div className="mx-auto grid max-w-5xl gap-10 px-5 md:grid-cols-[0.8fr_1.2fr] md:gap-14" data-id="element-124" data-mp="2dargyhy43qxy">
        <div data-id="element-125" data-mp="28h6ot6j79r6o">
          <p className="font-sans text-xs font-bold uppercase tracking-[0.24em] text-gold" data-id="element-126" data-mp="28gnadzsrdkxe">
            Format
          </p>
          <h2 id="format-heading" className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-espresso" data-id="element-127" data-mp="2i8tbq04whep9">
            All the content is PDF. No videos, no audiobooks.
          </h2>
        </div>
        <div data-id="element-128" data-mp="2s78r55ukezix">
          <p className="max-w-prose font-sans text-lg leading-relaxed text-cocoa" data-id="element-129" data-mp="2s4mkd8fi0o1r">
            You get printable documents you can use straight at the chair — no platform to
            log into, no video course to sit through and nothing to listen to.
          </p>
          <ul className="mt-7 space-y-3" data-id="element-130" data-mp="2z0m1d48d40wi">
            {formatPoints.map(point => <li key={point} className="flex items-start gap-3" data-id="element-131" data-mp="33zfgt277m1zb">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-132" data-mp="38xgvzc1ilh5i" />
                <span className="font-sans text-base text-cocoa" data-id="element-133" data-mp="3doyza6r0fttn">{point}</span>
              </li>)}
          </ul>
          <p className="mt-7 flex items-center gap-2 font-sans text-sm font-semibold text-muted" data-id="element-134" data-mp="3ipcyczamvtfj">
            <FileTextIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-135" data-mp="3mqyi94ll57z8" />
            11 PDF files · 240+ pages · Instant download
          </p>
        </div>
      </div>
    </section>;
}